import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface StepCreationMenuState {
  openMenuPath: string | null
}

export const initialState: StepCreationMenuState = {
  openMenuPath: null
}

export const slice = createSlice({
  name: 'stepCreationMenu',
  initialState,
  reducers: {
    openStepCreationMenuAtPath: (state, action: PayloadAction<{ path: string }>) => {
      const { path } = action.payload
      state.openMenuPath = path
    },
    closeStepCreationMenu: state => {
      state.openMenuPath = null
    }
  }
})

export const reducer = slice.reducer
export const actions = slice.actions
